<template>
	<div>
		<div class=" align-items-center" :class="[!isphone?'d-flex':'']">
			<!-- 左边 -->
			<slot name="left" >
				
			</slot>
			
			<!-- 右边 -->
			<div class="ml-auto" v-show="!superSearch" :class="[isphone?'mt-3':'']">
				<slot name="right">
					<el-input style="width: 150px;" class="mr-2" clearable="" v-model="keyword" size="mini" :placeholder="placeholder"></el-input>
					<el-button type="info" size="mini" @click="$emit('search',keyword)">搜索 </el-button>
					<el-button  size="mini"  v-show="showGj"
					@click="superSearch = true">高級搜索</el-button>
				</slot>
				
			</div>
		</div>
		
		<el-card class="box-card bg-light my-3" v-show="superSearch" >
			<div slot="header" class="clearfix" style="margin: -10px;">
				<span>高級搜索</span>
				<el-button style="float: right;padding: 3px 0;" type="text" @click="closeSuperSearch">收起</el-button>
			</div>
			
			<!-- 表單 -->
			<slot name="from">
				
			</slot>
			
		</el-card>
	</div>
</template>

<script>
	export default {
		props:{
			placeholder:{
				type:String,
				default:''
			},
			showGj:{
				type:Boolean,
				default:true
			},
			isphone:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				keyword: '',
				superSearch:true
			}
		},
		methods:{
			closeSuperSearch(){
				this.superSearch = false
			}
		}
	}
</script>

<style>
</style>
